import React from 'react';

export default {
  crossOut: {
    viewBox: '0 0 28 26',
    width: 28,
    height: 26,
    body: () => (
      <>
        <path
          d="M23 0H5a5 5 0 0 0-5 5v16a5 5 0 0 0 5 5h18a5 5 0 0 0 5-5V5a5 5 0 0 0-5-5z"
          fill="var(--current-background-color)"
        />
        <path
          d="M23 0H5C2.24 0 0 2.24 0 5v16c0 2.76 2.24 5 5 5h18c2.76 0 5-2.24 5-5V5c0-2.76-2.24-5-5-5zm4 21c0 2.21-1.79 4-4 4H5c-2.21 0-4-1.79-4-4V5c0-2.21 1.79-4 4-4h18c2.21 0 4 1.79 4 4v16z"
          fill="#1E1E1E"
        />
        <path
          d="M18.45 8.81s-.05.02-.07.04c-.25.16-.47.35-.66.57l-.64.53c-.13-.35-.32-.66-.63-.88-.54-.4-1.32-.59-2.36-.59H11.1v5.85L8.91 8.48H7.28L4.1 17.01h1.87l.59-1.76h3.08l.22.64-5.59 4.6.63.77 5.3-4.36 2.66-2.17v-.02l1.71-1.41h.02l5.99-4.92h-.02l3.73-3.07-.63-.77-5.2 4.28-.01-.01zM7.04 13.82l1.06-3.19 1.07 3.19H7.04zm5.82-.41v-.13h.16l-.16.13zm2.57-2.12-.84.69c-.13.03-.27.05-.43.06h-1.3V9.89h1.23c.48 0 .84.08 1.06.25.22.17.34.45.34.84 0 .12-.03.21-.06.31zM21.44 15.313c-.27.25-.67.37-1.22.37-.6 0-1.04-.21-1.32-.64-.28-.43-.42-1.1-.42-2.02v-.64c0-.41.04-.76.11-1.07l-1.89 1.55v.08s-.04-.02-.06-.04l-1.12.92c.1.18.16.38.16.65 0 .35-.12.62-.35.82-.23.2-.56.3-.97.3h-.98l-1.72 1.41h2.75c.97 0 1.71-.22 2.24-.64.29-.23.49-.53.62-.88.11.19.23.38.37.54.63.74 1.49 1.11 2.58 1.11 1 0 1.81-.26 2.42-.79.61-.53.95-1.25 1.02-2.17H21.9c-.04.52-.19.9-.46 1.15v-.01zM21.82 8.648l-1.41 1.16c.45.02.82.13 1.05.35.26.25.42.65.46 1.2h1.76c-.09-.95-.44-1.69-1.04-2.22-.24-.21-.51-.37-.81-.49h-.01z"
          fill="var(--current-text-color)"
        />
      </>
    ),
  },
  mcqRadioCrossout: {
    viewBox: '0 0 26 20',
    width: 26,
    height: 20,
    body: () => (
      <>
        <path
          d="M13 19.25C7.9 19.25 3.75 15.1 3.75 10C3.75 4.9 7.9 0.75 13 0.75C18.1 0.75 22.25 4.9 22.25 10C22.25 15.1 18.1 19.25 13 19.25ZM13 1.75C8.45 1.75 4.75 5.45 4.75 10C4.75 14.55 8.45 18.25 13 18.25C17.55 18.25 21.25 14.55 21.25 10C21.25 5.45 17.55 1.75 13 1.75Z"
          fill="#1E1E1E"
        />
        <path
          d="M0.700783 10.4297L25.8008 10.4297V9.42969L0.700783 9.42969V10.4297Z"
          fill="#1E1E1E"
        />
      </>
    ),
  },
  mcqCheckoutCrossout: {
    viewBox: '0 0 28 26',
    width: 28,
    height: 26,
    body: () => (
      <>
        <path
          d="M23 0H5a5 5 0 0 0-5 5v16a5 5 0 0 0 5 5h18a5 5 0 0 0 5-5V5a5 5 0 0 0-5-5z"
          fill="#fff"
        />
        <path
          d="M14 21.75a8.75 8.75 0 1 0 0-17.5 8.75 8.75 0 0 0 0 17.5z"
          fill="#fff"
        />
        <rect
          x="4.5"
          y="3.5"
          width="19"
          height="19"
          rx="1.5"
          fill="#fff"
          stroke="#1E1E1E"
        />
        <path d="M0 14h28v-1H0v1z" fill="#1E1E1E" />
      </>
    ),
  },
  timer_icon: {
    width: '16',
    height: '17',
    viewBox: '0 0 16 17',
    body: () => (
      <>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M11.5 0h-7v1.75h2.633v1.303C3.68 3.482 1 6.434 1 10c0 3.86 3.14 7 7 7s7-3.14 7-7a6.973 6.973 0 0 0-1.825-4.708l1.43-1.43-1.238-1.237-1.526 1.526a6.956 6.956 0 0 0-2.958-1.096V1.75H11.5V0zM2.75 10A5.255 5.255 0 0 0 8 15.25 5.255 5.255 0 0 0 13.25 10 5.255 5.255 0 0 0 8 4.75 5.255 5.255 0 0 0 2.75 10zm4.375.875V6.5h1.75v2.625H11.5v1.75H7.125z"
          fill="#888"
        />
      </>
    ),
  },
  pause_screen_quiz_title: {
    width: '32',
    height: '32',
    viewBox: '0 0 32 32',
    body: () => (
      <>
        <circle cx="16" cy="16" r="15.5" stroke="#505050" />
        <path
          d="M23.47 11.38H13.12c-.29 0-.53-.24-.53-.53 0-.29.24-.53.53-.53h10.35c.29 0 .53.24.53.53 0 .29-.24.53-.53.53zM23.47 16.53H13.12c-.29 0-.53-.24-.53-.53 0-.29.24-.53.53-.53h10.35c.29 0 .53.24.53.53 0 .29-.24.53-.53.53zM23.47 21.68H13.12c-.29 0-.53-.24-.53-.53 0-.29.24-.53.53-.53h10.35c.29 0 .53.24.53.53 0 .29-.24.53-.53.53zM9.29 12.14a1.29 1.29 0 1 0 0-2.58 1.29 1.29 0 0 0 0 2.58zM9.29 17.29a1.29 1.29 0 1 0 0-2.58 1.29 1.29 0 0 0 0 2.58zM9.29 22.44a1.29 1.29 0 1 0 0-2.58 1.29 1.29 0 0 0 0 2.58z"
          fill="#fff"
        />
      </>
    ),
  },
  bookmark: {
    viewBox: '0 0 17 22',
    width: '17',
    height: '22',
    body: () => (
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1 1h15v19l-7.5-5.429L1 20V1z"
        stroke="#1E1E1E"
        strokeWidth="2"
      />
    ),
  },
  column_expander: {
    width: '16',
    height: '16',
    viewBox: '0 0 16 16',
    body: () => (
      <>
        <path
          d="M1.4 8H0v8h8V8.99l3.1-3.1V9.5h1.4v-6h-6v1.4h3.61L7.01 8H1.4zm0 1.4h5.2v5.2H1.4V9.4z"
          fill="#666"
        />
        <path d="M1.4 0H16v16h-6v-1.4h4.6V1.4H1.4V6H0V0h1.4z" fill="#666" />
      </>
    ),
  },
  calculator: {
    width: '11',
    height: '14',
    viewBox: '0 0 11 14',
    body: () => (
      <>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0 13.385h10.952V.5H0v12.885zm.967-.966h9.02V1.467H.966v10.952z"
          fill="#1E1E1E"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M1.932 5.497h7.087v-2.9H1.932v2.9zm.967-.962h5.154v-.967H2.899v.967zM1.932 7.431h1.61v-.966h-1.61v.966zM4.67 7.431H6.28v-.966H4.67v.966zM9.022 6.414H7.41V7.43h1.61V6.414zM1.932 9.357h1.61v-.966h-1.61v.966zM4.67 9.357H6.28v-.966H4.67v.966zM9.022 8.39H7.41v.967h1.61v-.966zM1.934 11.293h1.61v-.967h-1.61v.967zM4.67 11.293H6.28v-.967H4.67v.967zM7.408 11.293h1.61v-.967h-1.61v.967z"
          fill="#1E1E1E"
        />
      </>
    ),
  },
  question_calculator: {
    width: '14',
    height: '17',
    viewBox: '0 0 14 17',
    body: () => (
      <path
        fill="#E57200"
        fillRule="evenodd"
        d="M0 0h14v17H0V0zm2 2v3h10V2H2zm0 5v2h2V7H2zm8 0v2h2V7h-2zM6 7v2h2V7H6zm-4 3v2h2v-2H2zm8 0v2h2v-2h-2zm-4 0v2h2v-2H6zm-4 3v2h2v-2H2zm8 0v2h2v-2h-2zm-4 0v2h2v-2H6z"
      />
    ),
  },
  reference: {
    width: '18',
    height: '12',
    viewBox: '0 0 18 12',
    body: () => (
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.644 3.718c.099-.074.2-.145.304-.21l.29-.18c.185-.111.346-.214.484-.302.137-.091.265-.188.382-.291.17-.154.31-.324.423-.511.11-.187.165-.41.165-.665a.996.996 0 0 0-.409-.846A1.381 1.381 0 0 0 16.827.5a2.193 2.193 0 0 0-.568-.07c-.18 0-.347.017-.501.05a3.264 3.264 0 0 0-.42.122 2.32 2.32 0 0 0-.333.155 3.55 3.55 0 0 0-.24.152l-.183.98c.257-.202.5-.355.727-.456.228-.101.463-.152.706-.152.198 0 .337.043.416.129a.422.422 0 0 1 .118.297.582.582 0 0 1-.158.409 2.398 2.398 0 0 1-.416.348c-.243.162-.48.317-.71.463a5.134 5.134 0 0 0-.635.477 3.088 3.088 0 0 0-.561.67c-.157.256-.273.58-.344.972h3.358l.25-1.284a.85.85 0 0 0-.22-.081.936.936 0 0 0-.22-.027c-.062 0-.136.006-.222.02a1.01 1.01 0 0 0-.25.074l-.094.466h-1.204c.068-.094.147-.182.237-.263.09-.081.184-.16.284-.233M12.783.848H8.487a1.186 1.186 0 0 0-.31.447c-.07.173-.105.342-.105.508 0 .056.004.125.011.208.007.083.038.2.094.353h1.12L7.118 4.356 5.519.848H2.572c-.276.264-.414.616-.414 1.059 0 .07.003.142.01.218.008.076.031.218.073.425h1.432l1.618 3.549-4.005 3.819H.414C.137 10.18 0 10.533 0 10.976c0 .069.003.143.01.218.006.076.031.218.073.425h4.565c.139-.125.241-.272.312-.445a1.39 1.39 0 0 0 .103-.51c0-.054-.004-.124-.009-.207-.007-.083-.04-.2-.094-.352H3.652l2.449-2.221 1.681 3.735h2.926c.291-.262.436-.615.436-1.058 0-.07-.004-.142-.01-.218a3.156 3.156 0 0 0-.093-.425H9.63L7.928 6.14l3.755-3.59h.769c.29-.262.435-.616.435-1.057 0-.071-.003-.143-.009-.22a3.383 3.383 0 0 0-.095-.425"
        fill="#1E1E1E"
      />
    ),
  },
  more: {
    width: '17',
    height: '16',
    viewBox: '0 0 17 16',
    body: () => (
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.787 3h2v2h-2V3zm0 4h2v2h-2V7zm2 4h-2v2h2v-2z"
        fill="#1E1E1E"
      />
    ),
  },
  help_menu: {
    width: '20',
    height: '20',
    viewBox: '0 0 20 20',
    body: () => (
      <>
        <circle cx="10" cy="10" r="10" fill="#fff" />
        <path
          d="M9.49999 19C7.62107 19 5.78437 18.4428 4.2221 17.399C2.65983 16.3551 1.44217 14.8714 0.723137 13.1355C0.00410414 11.3996 -0.184011 9.48946 0.182548 7.64664C0.549108 5.80382 1.45386 4.11111 2.78246 2.78251C4.11106 1.45391 5.80384 0.549092 7.64666 0.182533C9.48948 -0.184027 11.3996 0.00414944 13.1355 0.723182C14.8714 1.44221 16.3551 2.65982 17.399 4.22208C18.4429 5.78435 19 7.62111 19 9.50004C18.9973 12.0188 17.9956 14.4336 16.2146 16.2146C14.4336 17.9957 12.0187 18.9974 9.49999 19ZM9.49999 1.19999C7.85841 1.19999 6.25371 1.68678 4.88879 2.59879C3.52386 3.51081 2.45999 4.80714 1.83178 6.32377C1.20357 7.84039 1.03923 9.50926 1.35949 11.1193C1.67975 12.7293 2.47026 14.2083 3.63103 15.3691C4.79181 16.5298 6.27069 17.3203 7.88073 17.6405C9.49077 17.9608 11.1596 17.7965 12.6763 17.1683C14.1929 16.54 15.4892 15.4762 16.4012 14.1112C17.3132 12.7463 17.8 11.1416 17.8 9.50004C17.7973 7.29955 16.9221 5.18993 15.3661 3.63395C13.8101 2.07797 11.7005 1.20264 9.49999 1.19999Z"
          fill="#1E1E1E"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M9.50092 4.00013C8.56286 4.00277 7.66398 4.37661 7.00067 5.03992C6.33736 5.70323 5.96358 6.60211 5.96094 7.54017H7.59094C7.57196 7.27839 7.60714 7.01552 7.69427 6.76795C7.78141 6.52037 7.9186 6.29338 8.09735 6.1012C8.2761 5.90902 8.49253 5.75569 8.73315 5.65088C8.97378 5.54607 9.23345 5.49207 9.49591 5.49207C9.75837 5.49207 10.018 5.54607 10.2587 5.65088C10.4993 5.75569 10.7157 5.90902 10.8945 6.1012C11.0732 6.29338 11.2105 6.52037 11.2976 6.76795C11.3847 7.01552 11.4199 7.27839 11.4009 7.54017C11.402 7.93199 11.2965 8.31675 11.0957 8.6532C10.8949 8.98966 10.6063 9.26505 10.2609 9.45008C9.78901 9.73034 9.39626 10.1263 9.11981 10.6005C8.84336 11.0746 8.69232 11.6114 8.68091 12.1602H10.3109C10.3109 11.5102 10.6209 11.2401 11.3109 10.7401C11.8527 10.4009 12.2988 9.92896 12.6068 9.3689C12.9148 8.80884 13.0746 8.17934 13.0709 7.54017C13.0709 7.07275 12.9784 6.60993 12.7986 6.17847C12.6188 5.74701 12.3554 5.35536 12.0235 5.02625C11.6916 4.69714 11.2978 4.43712 10.8648 4.26099C10.4318 4.08486 9.96831 3.99617 9.50092 4.00013Z"
          fill="#1E1E1E"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M8.7207 15.7007H10.3507V13.8008H8.7207V15.7007Z"
          fill="#1E1E1E"
        />
      </>
    ),
  },
  shortcuts: {
    width: '16',
    height: '16',
    viewBox: '0 0 16 16',
    body: () => (
      <path
        filRule="evenodd"
        clipRule="evenodd"
        d="M.96 13.44V3.36h14.08v10.08H.96zM0 3.2a.8.8 0 0 1 .8-.8h14.4a.8.8 0 0 1 .8.8v10.4a.8.8 0 0 1-.8.8H.8a.8.8 0 0 1-.8-.8V3.2zm13.6 7.2H2.4v1.12h11.2V10.4zM12 7.52a.32.32 0 0 1 .32-.32h.96a.32.32 0 0 1 .32.32v.96a.32.32 0 0 1-.32.32h-.96a.32.32 0 0 1-.32-.32v-.96zm.32-2.72a.32.32 0 0 0-.32.32v.96c0 .177.143.32.32.32h.96a.32.32 0 0 0 .32-.32v-.96a.32.32 0 0 0-.32-.32h-.96zm-3.52.32a.32.32 0 0 1 .32-.32h.96a.32.32 0 0 1 .32.32v.96a.32.32 0 0 1-.32.32h-.96a.32.32 0 0 1-.32-.32v-.96zM2.72 7.2a.32.32 0 0 0-.32.32v.96c0 .177.143.32.32.32h.96A.32.32 0 0 0 4 8.48v-.96a.32.32 0 0 0-.32-.32h-.96zM2.4 5.12a.32.32 0 0 1 .32-.32h.96a.32.32 0 0 1 .32.32v.96a.32.32 0 0 1-.32.32h-.96a.32.32 0 0 1-.32-.32v-.96zM5.92 7.2a.32.32 0 0 0-.32.32v.96c0 .177.143.32.32.32h.96a.32.32 0 0 0 .32-.32v-.96a.32.32 0 0 0-.32-.32h-.96zM5.6 5.12a.32.32 0 0 1 .32-.32h.96a.32.32 0 0 1 .32.32v.96a.32.32 0 0 1-.32.32h-.96a.32.32 0 0 1-.32-.32v-.96zM9.12 7.2a.32.32 0 0 0-.32.32v.96c0 .177.143.32.32.32h.96a.32.32 0 0 0 .32-.32v-.96a.32.32 0 0 0-.32-.32h-.96z"
        fill="#1E1E1E"
      />
    ),
  },
  assistive_tech: {
    width: '20',
    height: '20',
    viewBox: '0 0 20 20',
    body: () => (
      <>
        <defs>
          <clipPath id="q5ymsqrkba">
            <path fill="#fff" d="M0 0h20v20H0z" />
          </clipPath>
        </defs>
        <g clipPath="url(#q5ymsqrkba)" fill="#1E1E1E">
          <path d="M10 4.678c-.624 0-1.212-.25-1.65-.687a2.366 2.366 0 0 1-.674-1.663c0-.625.237-1.212.675-1.662.875-.888 2.425-.888 3.3 0 .437.437.675 1.025.675 1.65s-.238 1.212-.675 1.662a2.276 2.276 0 0 1-1.65.688v.012zm0-3.287a.937.937 0 0 0-.65 1.6.92.92 0 0 0 1.563-.663c0-.25-.1-.487-.275-.662a.908.908 0 0 0-.65-.275h.013z" />
          <path d="M11.212 19.997A1.87 1.87 0 0 1 10 19.559a1.87 1.87 0 0 1-1.213.438 1.92 1.92 0 0 1-1.912-1.913V8.847L2.887 4.872a1.762 1.762 0 0 1-.025-2.463c.325-.35.775-.537 1.25-.55.488.025.925.175 1.263.513L8.45 5.447c.825.825 2.262.825 3.087 0l3.075-3.075c.338-.338.8-.488 1.263-.513.475 0 .925.2 1.25.55.65.688.637 1.788-.025 2.463l-3.988 3.987v9.238a1.92 1.92 0 0 1-1.912 1.912l.012-.012zM10 13.522c.387 0 .7.312.7.7v3.862c0 .275.225.5.5.5s.5-.225.5-.5V8.56a.7.7 0 0 1 .212-.5L16.1 3.872a.34.34 0 0 0 0-.488.369.369 0 0 0-.25-.112.342.342 0 0 0-.25.1l-3.075 3.075c-1.363 1.362-3.725 1.362-5.088 0l-3.05-3.075c-.087-.088-.175-.088-.25-.1a.332.332 0 0 0-.25.112c-.125.138-.125.363 0 .488l4.188 4.187a.7.7 0 0 1 .212.5v9.525c0 .275.225.5.5.5s.5-.225.5-.5v-3.85c0-.387.313-.7.7-.7l.013-.012z" />
        </g>
      </>
    ),
  },
  line_reader: {
    width: '16',
    height: '16',
    viewBox: '0 0 16 16',
    body: () => (
      <path
        fill="#1E1E1E"
        d="M0 5h16v2H0zM3 1h10v1H3zM3 10h10v1H3zM3 14h10v1H3z"
      />
    ),
  },
  save_exit: {
    width: '24',
    height: '24',
    viewBox: '0 0 24 24',
    body: () => (
      <>
        <mask
          id="mask0_6950_18642"
          style="mask-type:alpha"
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="24"
          height="24"
        >
          <rect width="24" height="24" fill="#D9D9D9" />
        </mask>
        <g mask="url(#mask0_6950_18642)">
          <path
            d="M5.30775 20.5C4.80258 20.5 4.375 20.325 4.025 19.975C3.675 19.625 3.5 19.1974 3.5 18.6923V5.30775C3.5 4.80258 3.675 4.375 4.025 4.025C4.375 3.675 4.80258 3.5 5.30775 3.5H12.0095V5H5.30775C5.23075 5 5.16025 5.03208 5.09625 5.09625C5.03208 5.16025 5 5.23075 5 5.30775V18.6923C5 18.7692 5.03208 18.8398 5.09625 18.9038C5.16025 18.9679 5.23075 19 5.30775 19H12.0095V20.5H5.30775ZM16.2308 16.2692L15.1923 15.1845L17.627 12.75H9.09625V11.25H17.627L15.1923 8.8155L16.2308 7.73075L20.5 12L16.2308 16.2692Z"
            fill="#1C1B1F"
          />
        </g>
      </>
    ),
  },
  sixDots: {
    width: '24',
    height: '24',
    viewBox: '0 0 24 24',
    body: () => (
      <>
        <path d="M7 15.5C7 14.3954 6.10457 13.5 5 13.5C3.89543 13.5 3 14.3954 3 15.5C3 16.6046 3.89543 17.5 5 17.5C6.10457 17.5 7 16.6046 7 15.5Z" />
        <path d="M7 8.5C7 7.39543 6.10457 6.5 5 6.5C3.89543 6.5 3 7.39543 3 8.5C3 9.60457 3.89543 10.5 5 10.5C6.10457 10.5 7 9.60457 7 8.5Z" />
        <path d="M12 13.5C13.1046 13.5 14 14.3954 14 15.5C14 16.6046 13.1046 17.5 12 17.5C10.8954 17.5 10 16.6046 10 15.5C10 14.3954 10.8954 13.5 12 13.5Z" />
        <path d="M14 8.5C14 7.39543 13.1046 6.5 12 6.5C10.8954 6.5 10 7.39543 10 8.5C10 9.60457 10.8954 10.5 12 10.5C13.1046 10.5 14 9.60457 14 8.5Z" />
        <path d="M19 13.5C20.1046 13.5 21 14.3954 21 15.5C21 16.6046 20.1046 17.5 19 17.5C17.8954 17.5 17 16.6046 17 15.5C17 14.3954 17.8954 13.5 19 13.5Z" />
        <path d="M21 8.5C21 7.39543 20.1046 6.5 19 6.5C17.8954 6.5 17 7.39543 17 8.5C17 9.60457 17.8954 10.5 19 10.5C20.1046 10.5 21 9.60457 21 8.5Z" />
      </>
    ),
  },
  reduceWindowSize: {
    width: '16',
    height: '16',
    viewBox: '0 0 16 16',
    body: () => (
      <path
        d="M13.99 6.15h-3.38L15 1.76 14.24 1l-4.4 4.4V2.01c0-.3-.24-.54-.54-.54-.3 0-.54.24-.54.54v4.67c0 .3.24.54.54.54h4.67c.3 0 .54-.24.54-.54 0-.3-.24-.54-.54-.54l.02.01zM6.69 8.783H2.01c-.3 0-.54.24-.54.54 0 .3.24.54.54.54h3.38L1 14.243l.76.76 4.4-4.4v3.38c0 .3.24.54.54.54.3 0 .54-.24.54-.54v-4.67c0-.3-.24-.54-.54-.54l-.01.01z"
        fill="#F7F7F7"
      />
    ),
  },
  increaseWindowSize: {
    width: '16',
    height: '16',
    viewBox: '0 0 16 16',
    body: () => (
      <path
        d="M14.47 1H9.81c-.29 0-.53.24-.53.53 0 .29.24.53.53.53h3.37L8.94 6.3l.75.75 4.24-4.23v3.37c0 .29.24.53.53.53.29 0 .53-.24.53-.53V1.53c0-.29-.24-.53-.53-.53h.01zM6.31 8.938l-4.24 4.24v-3.37c0-.29-.24-.53-.53-.53-.29 0-.53.24-.53.53v4.66c0 .29.24.53.53.53H6.2c.29 0 .53-.24.53-.53 0-.29-.24-.53-.53-.53H2.82l4.24-4.24-.75-.75v-.01z"
        fill="#F7F7F7"
      />
    ),
  },
  current_question: {
    width: '16',
    height: '16',
    viewBox: '0 0 16 16',
    body: () => (
      <>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8 13.443c-3.164-2.689-4.5-4.31-4.5-6.693C3.5 4.087 5.491 2 8.033 2 10.538 2 12.5 4.087 12.5 6.75c0 2.383-1.336 4.004-4.5 6.693M8.033 0C4.37 0 1.5 2.964 1.5 6.75c0 3.614 2.32 5.818 5.859 8.768l.641.533.641-.533c3.539-2.95 5.859-5.154 5.859-8.768C14.5 2.964 11.659 0 8.033 0"
          fill="#1E1E1E"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8 4.5a2 2 0 1 0 .001 4.001A2 2 0 0 0 8 4.5"
          fill="#1E1E1E"
        />
      </>
    ),
  },
  for_review: {
    width: '16',
    height: '16',
    viewBox: '0 0 16 16',
    body: () => (
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 0h12.8v16l-6.4-5.6L0 16V0z"
        fill="#C13145"
      />
    ),
  },
  apc_timer: {
    viewBox: '0 0 16 16',
    width: '16',
    height: '16',
    body: () => (
      <g fill="#000" fillRule="nonzero">
        <path d="M8 0a8 8 0 1 0 0 16A8 8 0 0 0 8 0zm0 14.4A6.4 6.4 0 1 1 8 1.6a6.4 6.4 0 0 1 0 12.8z" />
        <path d="M8 3.2H6.8v5.016c0 .543.44.984.984.984H12V8H8V3.2z" />
      </g>
    ),
  },
  highlight_teardrop: {
    viewBox: '0 0 32 32',
    width: '32',
    height: '32',
    body: () => (
      <>
        <g clipPath="url(#ytqq4h4fda)">
          <path d="m15.623 9.438-.84.874-1.262 2.626-1.683 2.624-.42 2.626.42 1.75 1.262 1.75 2.103.875h1.682l2.102-.875L20.25 19.5l.42-1.75-.42-1.313-3.785-7h-.84z" />
          <path
            d="M15.996 22.999C13.237 22.999 11 20.662 11 17.8c0-2.039 2.439-6.011 3.902-8.199.202-.306.505-.507.85-.577.353-.07.706.009 1 .219.135.096.253.218.346.358 1.455 2.18 3.902 6.152 3.902 8.2 0 2.87-2.246 5.197-4.996 5.197h-.008zm0-13.125s-.06 0-.093.008a.497.497 0 0 0-.31.21c-2.39 3.588-3.752 6.397-3.752 7.71 0 2.388 1.867 4.322 4.155 4.322 2.287 0 4.155-1.943 4.155-4.323 0-1.304-1.405-4.182-3.752-7.7a.459.459 0 0 0-.126-.131.457.457 0 0 0-.277-.088v-.008z"
            fill="#1E1E1E"
          />
          <path
            d="M15.995 20.357a.425.425 0 0 1-.42-.438c0-.245.184-.437.42-.437 1.026 0 1.867-.875 1.867-1.943 0-.245.185-.437.42-.437.236 0 .42.192.42.437 0 1.558-1.219 2.818-2.707 2.818z"
            fill="#1E1E1E"
          />
        </g>
        <defs>
          <clipPath id="ytqq4h4fda">
            <path fill="#fff" transform="translate(11 9)" d="M0 0h10v14H0z" />
          </clipPath>
        </defs>
      </>
    ),
  },
  image_upload: {
    viewBox: '0 0 23 17',
    width: '23',
    height: '17',
    body: () => (
      <path
        d="M2.84622 16.9375C2.27791 16.9375 1.79687 16.7406 1.40312 16.3469C1.00938 15.9531 0.8125 15.4721 0.8125 14.9038V2.09622C0.8125 1.52791 1.00938 1.04688 1.40312 0.653125C1.79687 0.259375 2.27791 0.0625 2.84622 0.0625H20.1538C20.7221 0.0625 21.2031 0.259375 21.5969 0.653125C21.9906 1.04688 22.1875 1.52791 22.1875 2.09622V14.9038C22.1875 15.4721 21.9906 15.9531 21.5969 16.3469C21.2031 16.7406 20.7221 16.9375 20.1538 16.9375H2.84622ZM2.84622 15.25H20.1538C20.2404 15.25 20.3197 15.2139 20.3917 15.1417C20.4639 15.0697 20.5 14.9904 20.5 14.9038V2.09622C20.5 2.00959 20.4639 1.93028 20.3917 1.85828C20.3197 1.78609 20.2404 1.75 20.1538 1.75H2.84622C2.75959 1.75 2.68028 1.78609 2.60828 1.85828C2.53609 1.93028 2.5 2.00959 2.5 2.09622V14.9038C2.5 14.9904 2.53609 15.0697 2.60828 15.1417C2.68028 15.2139 2.75959 15.25 2.84622 15.25ZM5.59375 13H17.4926L13.7933 8.06744L10.6346 12.1779L8.38459 9.30044L5.59375 13Z"
        fill="#1C1B1F"
      />
    ),
  },
};
